import { QueryClient } from "@tanstack/react-query";

const queryConfig = {
  queries: {
    // Auth 401s must not crash the app overlay
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
    retry: false,
  },
  mutations: {
    useErrorBoundary: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
